import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const EmailTemplate = Loadable(lazy(() => import('./sendEmail')));

const sendEmailRoutes = [
  { path: '/dashboard/send-email', element: <EmailTemplate />, auth: authRoles.admin },
];

export default sendEmailRoutes;
